import { useState } from "react";

import { ErrorNotice } from "../../components/feedback";
import { GoogleSignInButton } from "../../components/google-sign-in-button";
import { authClient } from "../../lib/auth-client";

/**
 * 管理画面のサインイン画面
 *
 * @returns サインイン画面
 */
export const SignInScreen = () => {
  // サインイン処理中かを保持する
  const [isSigningIn, setIsSigningIn] = useState(false);

  // 利用者向けエラーを保持する
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleSignIn = async () => {
    setIsSigningIn(true);
    setErrorMessage(null);

    try {
      const result = await authClient.signIn.social({
        provider: "google",
        callbackURL: `${window.location.origin}/`,
      });

      if (result.error) {
        setErrorMessage("このアカウントでは利用できません。");
      }
    } catch (error: unknown) {
      console.error("Google sign in failed", error);
      setErrorMessage("サインインできませんでした。時間をおいてもう一度お試しください。");
    } finally {
      setIsSigningIn(false);
    }
  };

  return (
    <main className="sign-in-page">
      <section className="sign-in-card" aria-labelledby="sign-in-title">
        <div className="sign-in-card__brand">
          <span className="brand__mark brand__mark--large" aria-hidden="true">
            C
          </span>
          <span>Codocolle</span>
        </div>
        <h1 id="sign-in-title">Codocolle管理画面</h1>
        {errorMessage ? <ErrorNotice message={errorMessage} /> : null}
        <GoogleSignInButton isLoading={isSigningIn} onClick={() => void handleSignIn()} />
      </section>
    </main>
  );
};
